<template>
  <div class="modal" v-show="visibilityFlag">
    <div class="mask"></div>
    <div class="modal-content">
      <img src="../assets/images/close.png" @click="close" class="close" alt />
      <div class="code" v-show="code">
        <h2>{{$t('code_config.title')}}</h2>
        <div class="copy">
          <p>{{code}}</p>
          <p v-clipboard:copy="code" @click="copy">{{$t('code_config.copy')}}</p>
          <span id="success">{{$t('code_config.success')}}</span>
        </div>
        <p class="download">{{$t('code_config.download')}}</p>
      </div>
      <div v-show="!code" :style="{ 'width':'90%', 'position':'relative' }">
        <div class="result" v-if="$t('get_reward.done')||$t('get_reward.failed')">
          <img :src="src" alt />
          <p class="title">{{type?$t('get_reward.done.title'):$t('get_reward.failed.title')}}</p>
          <div v-if="type" class="done">
            <p>{{$t('get_reward.done.content[0]')}}</p>
            <p>{{$t('get_reward.done.content[1]')}}</p>
          </div>
          <div class="failed" v-else>{{message}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import done from "../assets/images/done.png";
import failed from "../assets/images/failed.png";
import { computed } from "vue-function-api";
export default {
  props: {
    visibilityFlag: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ""
    },
    type: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    const close = () => {
      context.emit("update:visibilityFlag", false);
    };
    const src = computed(() => {
      return props.type ? done : failed;
    });
    const copy = () => {
      document.getElementById("success").className = "fadein";
      setTimeout(() => {
        document.getElementById("success").className = "";
      }, 1000);
    };
    return {
      close,
      src,
      copy
    };
  }
};
</script>

<style lang="scss" scoped>
// $u: 0.01333333334;
// $h: $u * 190rem;
// .modal {
//   z-index: 1002;
//   width: 100%;
//   background-size: 100% 100%;
//   position: relative;
//   box-sizing: border-box;
//   position: relative;
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   position: fixed;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   .mask {
//     z-index: 1;
//     width: 100%;
//     position: absolute;
//     top: 0;
//     left: 0;
//     bottom: 0;
//     right: 0;
//     background: url("../assets/images/mask.png") center no-repeat;
//     background-size: 100% 100%;
//   }
//   .content {
//     z-index: 1000;
//     width: $u * 642rem;
//     height: $u * 462rem;
//     background: url("../assets/images/code_background.png") center no-repeat;
//     background-size: 100% 100%;
//     position: relative;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     .close {
//       width: $u * 32rem;
//       height: $u * 32rem;
//       position: absolute;
//       right: $u * 40rem;
//       top: -$u * 30rem;
//     }
//     .code {
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justify-content: center;
//       p {
//         margin: 0;
//       }
//       h2 {
//         font-size: $u * 40rem;
//         font-weight: 600;
//         color: rgba(71, 48, 21, 1);
//         // line-height: $u * 76rem;
//         margin: 0;
//         margin-bottom: $u * 30rem;
//       }
//       .copy {
//         margin-bottom: $u * 30rem;
//         display: flex;
//         align-items: center;
//         p:first-child {
//           font-size: $u * 48rem;
//           font-weight: 800;
//           color: rgba(137, 41, 4, 1);
//           // line-height: $u * 91rem;
//           margin-right: $u * 10rem;
//         }
//         p:last-child {
//           font-size: $u * 26rem;
//           font-weight: 800;
//           color: rgba(137, 41, 4, 1);
//           height: $u * 40rem;
//           border-bottom: 1px solid rgba(137, 41, 4, 1);
//         }
//       }
//       .download {
//         font-size: $u * 24rem;
//         font-weight: 600;
//         color: rgba(71, 48, 21, 1);
//         // line-height: $u * 39rem;
//       }
//     }
//     .result {
//       text-align: center;
//       img {
//         width: $u * 90rem;
//         height: $u * 90rem;
//       }
//       p {
//         margin: 0;
//       }
//       .title {
//         font-size: $u * 40rem;
//         font-weight: 800;
//         color: rgba(137, 41, 4, 1);
//         line-height: $u * 76rem;
//         margin-bottom: $u * 20rem;
//       }
//       .done,
//       .failed {
//         font-size: $u * 24rem;
//         font-weight: 600;
//         color: rgba(71, 48, 21, 1);
//         line-height: $u * 40rem;
//       }
//     }
//   }
// }
</style>